import React from "react";
import { bool, shape, string } from "prop-types";
import { Box } from "@mui/material";
import UnpublishedChip from "./UnpublishedChip";

import { newItemPeriod } from "../config";
import { differenceInDays, determineComparisonDate } from "../utils/date";
import NewChip from "./NewChip";

const ItemBadges = ({ item, positioned = true, size = "medium" }) => {
  const comparisonDate = determineComparisonDate(item.created_at, item.display_date);
  const itemIsNew = differenceInDays([comparisonDate, new Date()]) < newItemPeriod;
  const { unpublished } = item;
  if (unpublished || itemIsNew) {
    return (
      <Box
        sx={{
          display: "flex",
          gap: 0.5,
          ...(positioned && {
            position: "absolute",
            left: 10,
            top: 10,
            zIndex: 100,
          }),
        }}
      >
        {unpublished && <UnpublishedChip size={size} />}
        {itemIsNew && <NewChip size={size} />}
      </Box>
    );
  } else {
    return null;
  }
};

ItemBadges.propTypes = {
  item: shape({
    created_at: string,
    display_date: string,
    unpublished: bool,
  }).isRequired,
  positioned: bool,
  size: string,
};

export default ItemBadges;
